<template>
    <div :class="containerClass">
        <div v-if="showGuard" class="center-on-page has-text-centered">
            <div>
                <div class="m-b-sm">
                    <i class="fa fa-warning fa-2x"></i>
                </div>
                You wont be able to access this page while your account is in a {{status.name}} status
            </div>
        </div>
        <router-view v-else></router-view>
    </div>
</template>

<script>
import StatusUtil from "../util/StatusUtil";

export default {
    computed : {
        status () {
            return StatusUtil.DEALER.findById(this.$getDealer().accountDealerStatusId);
        },
        showGuard () {
            if(!this.$route.meta || !this.status) {
                return false;
            }
            return this.$route.meta.accessGuard === true
                && (
                    this.status.id === StatusUtil.DEALER.PENDING.id
                    || this.status.id === StatusUtil.DEALER.DENIED.id
                    || this.status.id === StatusUtil.DEALER.CANCELED.id
                );
        },
        containerClass () {
            return {
                'page-con' : true,
                'is-exact-height' : this.showGuard,
            };
        }
    },
}
</script>

<style scoped>
    .center-on-page {
        font-weight:bold;
    }
</style>
